import React, { useEffect, useState } from 'react';
import {
  getAnalyticsConsent,
  initAnalyticsIfConsented,
  optInAnalytics,
  optOutAnalytics,
  ensureAnalyticsIdle,
} from '@/lib/analytics';

/**
 * DSGVO Opt-in: PostHog erst nach „Akzeptieren“.
 * Default = keine Entscheidung → Banner sichtbar, kein Tracking-Skript.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const current = getAnalyticsConsent();
    if (current === 'granted') {
      initAnalyticsIfConsented();
      setVisible(false);
      return;
    }
    // denied or undecided: never load PostHog; scrub leftover keys (old projects)
    ensureAnalyticsIdle();
    if (current === 'denied') {
      setVisible(false);
      return;
    }
    setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[100] p-4 sm:p-6 pointer-events-none"
    >
      <div className="mx-auto max-w-3xl pointer-events-auto rounded-xl border border-slate-200 bg-white shadow-xl p-4 sm:p-5">
        <h2 id="cookie-consent-title" className="text-sm font-semibold text-slate-900">
          Statistik &amp; Reichweitenmessung
        </h2>
        <p id="cookie-consent-desc" className="mt-1.5 text-xs sm:text-sm text-slate-600 leading-relaxed">
          Wir nutzen optional PostHog (EU-Cloud), um die Nutzung der Verwaltung zu
          verbessern (Seitenaufrufe, technische Fehler). Es werden keine
          Sitzungsaufzeichnungen erstellt. Ohne Ihre Einwilligung wird kein
          Analyse-Skript geladen und kein Analyse-Cookie gesetzt.
        </p>
        <div className="mt-3 flex flex-wrap gap-2 justify-end">
          <button
            type="button"
            data-testid="cookie-consent-deny"
            onClick={() => { optOutAnalytics(); setVisible(false); }}
            className="px-3 py-1.5 text-xs sm:text-sm rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50"
          >
            Ablehnen
          </button>
          <button
            type="button"
            data-testid="cookie-consent-accept"
            onClick={() => { optInAnalytics(); setVisible(false); }}
            className="px-3 py-1.5 text-xs sm:text-sm rounded-lg bg-slate-800 text-white hover:bg-slate-900"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
